import { Web3AuthOptions } from '@web3auth/modal'
import { OPENLOGIN_NETWORK_TYPE, OpenloginAdapterOptions } from '@web3auth/openlogin-adapter'
import { WALLET_ADAPTERS } from '@web3auth/base'

import blockchainConfig from '../../constants/blockchain'

function isNetworkType(value: any): value is OPENLOGIN_NETWORK_TYPE {
  return value === 'mainnet' || value === 'cyan' || value === 'testnet'
}

const web3AuthNetwork: OPENLOGIN_NETWORK_TYPE = isNetworkType(process.env.WEB3AUTH_NETWORK)
  ? process.env.WEB3AUTH_NETWORK
  : 'testnet'

export const web3AuthOptions: Omit<Web3AuthOptions, 'chainConfig'> = {
  clientId: blockchainConfig.WEB3AUTH_CLIENT_ID,
  web3AuthNetwork,
  uiConfig: {
    appName: 'LAMINA1', // <-- Your dApp Name
    logoLight:
      'https://uploads-ssl.webflow.com/63fe332d7b9ae4159d741e55/640b9679f321ab6b6af536fd_favicon.jpg',
    logoDark:
      'https://uploads-ssl.webflow.com/63fe332d7b9ae4159d741e55/640b9679f321ab6b6af536fd_favicon.jpg',
    // TODO: if the user's browser settings prefer dark theme, but then the user changes to light theme,
    //       the auth modal will still be in dark theme because the "auto" option always gets the setting
    //       from the browser. To fix this, the user-defined theme needs to be used here instead of "auto".
    //       A HOC needs to be created to wrap the WagmiConfig provider and replace the "auto" option with
    //       the user-defined theme. Same thing would happen if the browser's setting is light theme and
    //       the user changes to dark theme.
    mode: 'auto',
    loginMethodsOrder: ['discord', 'google', 'twitter'],
    defaultLanguage: 'en', // en, de, ja, ko, zh, es, fr, pt, nl
    loginGridCol: 2, // 2 | 3
    primaryButton: 'externalLogin', // "externalLogin" | "socialLogin" | "emailLogin",
  },
  enableLogging: false,
}

export const openLoginAdapterOptions: OpenloginAdapterOptions = {
  loginSettings: {
    mfaLevel: 'optional',
  },
  adapterSettings: {
    network: web3AuthNetwork,
    uxMode: 'redirect',
    redirectUrl: `${window.location.origin}/loggedIn`,
    replaceUrlOnRedirect: true,
    whiteLabel: {
      appName: 'Lamina1',
      logoDark:
        'https://uploads-ssl.webflow.com/63fe332d7b9ae4159d741e55/640b9679f321ab6b6af536fd_favicon.jpg',
      logoLight:
        'https://uploads-ssl.webflow.com/63fe332d7b9ae4159d741e55/640b9679f321ab6b6af536fd_favicon.jpg',
      defaultLanguage: 'en', // en, de, ja, ko, zh, es, fr, pt, nl
      // TODO: if the user's browser settings prefer dark theme, but then the user changes to light theme,
      //       the auth modal will still be in dark theme because the "auto" option always gets the setting
      //       from the browser. To fix this, the user-defined theme needs to be used here instead of "auto".
      //       A HOC needs to be created to wrap the WagmiConfig provider and replace the "auto" option with
      //       the user-defined theme. Same thing would happen if the browser's setting is light theme and
      //       the user changes to dark theme.
      mode: 'auto', // whether to enable dark mode. defaultValue: false
    },
  },
}

export const initModalParams = {
  modalConfig: {
    // Disable WalletConnect
    [WALLET_ADAPTERS.WALLET_CONNECT_V2]: {
      label: 'wallet_connect',
      showOnModal: false,
    },
    // Disable Torus
    [WALLET_ADAPTERS.TORUS_EVM]: {
      label: 'Torus Wallet',
      showOnModal: false,
    },
    [WALLET_ADAPTERS.OPENLOGIN]: {
      label: 'openlogin',
      loginMethods: {
        // Disable some social logins
        apple: {
          name: 'apple',
          showOnModal: false,
        },
        twitch: {
          name: 'twitch',
          showOnModal: false,
        },
        facebook: {
          name: 'facebook',
          showOnModal: false,
        },
        reddit: {
          name: 'reddit',
          showOnModal: false,
        },
        line: {
          name: 'line',
          showOnModal: false,
        },
        github: {
          name: 'github',
          showOnModal: false,
        },
        wechat: {
          name: 'wechat',
          showOnModal: false,
        },
        kakao: {
          name: 'kakao',
          showOnModal: false,
        },
        linkedin: {
          name: 'linkedin',
          showOnModal: false,
        },
        weibo: {
          name: 'weibo',
          showOnModal: false,
        },
        // Disable sms_passwordless
        sms_passwordless: {
          name: 'sms_passwordless',
          showOnModal: false,
        },
      },
    },
  },
}
